import { Box, Typography } from "@mui/material";
import SideDrawer from "../../../Drawer/Drawer";

function PartnerFeeDrawer({ isOpen, setIsOpen, drawerData }) {
  return (
    <SideDrawer setIsOpen={setIsOpen} isOpen={isOpen}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}>
        <Box p={2}>
          <Typography fontSize={"22px"} fontWeight={"500"} textAlign={"center"}>
            More Details
          </Typography>
        </Box>
        <Box p={2} pt={4} width={"70%"}>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Partner Fee:</Typography>
            <Typography>{drawerData?.partnerFee ? "True" : "False"}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Term 01 ($/%):</Typography>
            <Typography>{drawerData?.termOne}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Slab 01:</Typography>
            <Typography>{drawerData?.slabOne}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Term 02 ($/%):</Typography>
            <Typography>{drawerData?.termTwo}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Slab 02:</Typography>
            <Typography>{drawerData?.slabTwo}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Term 03 ($/%):</Typography>
            <Typography>{drawerData?.termThree}</Typography>
          </Box>
          <Box display={"flex"} justifyContent={"space-between"} paddingY={1}>
            <Typography>Slab 03:</Typography>
            <Typography>{drawerData?.slabThree}</Typography>
          </Box>
        </Box>
      </Box>
    </SideDrawer>
  );
}

export default PartnerFeeDrawer;
